export enum FleetStorageKey {
  ADD_FLEET_FORM = 'addFleetForm',
}
